import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../react-hooks/use-services.hook";
import {LoginToastBox} from "./boxes/login-toast.box";
import {FlexContainerBox, FlexFixedSizeItemBox, FlexGrowItemBox} from "../../themes/architecture/css-helpers/flex";
import {DefaultToastImageBox} from "../toaster/toasts-content/boxes/default-toast-image.box";
import {StandardToastTitleBox} from "../toaster/toasts-content/boxes/standard-toast-title.box";
import {StandardToastMessageBox} from "../toaster/toasts-content/boxes/standard-toast-message.box";
import {ILoginToastProps} from "../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/login-toast.component-props";
import {LoginToastResponsibleGamingLinkBox} from "./boxes/login-toast-message/login-toast-responsible-gaming-link.box";

interface ILoginToastComponentProps {
    contentProps: ILoginToastProps;
}
export const LoginToastComponent: React.FC<ILoginToastComponentProps> = observer((props) => {
    const services = useServices();

    const DefaultIcon = services.theme.currentTheme.icons.infoIcon;
    const renderImage = () => {
        return <DefaultToastImageBox><DefaultIcon size={3} /></DefaultToastImageBox>;
    }

    return (
        <LoginToastBox>
            <FlexContainerBox alignItems="center">
                <FlexFixedSizeItemBox>
                    {renderImage()}
                </FlexFixedSizeItemBox>
            </FlexContainerBox>
            <FlexGrowItemBox flexBasis="150px">
                <StandardToastTitleBox>
                    {props.contentProps.title}
                </StandardToastTitleBox>
                <StandardToastMessageBox>
                    {props.contentProps.contentText}
                </StandardToastMessageBox>
                <LoginToastResponsibleGamingLinkBox onClick={() => services.linksNavigation.openResponsibleGaming()}>
                    {services.translation.translate('RESPONSIBLE_GAMBLING')}
                </LoginToastResponsibleGamingLinkBox>
            </FlexGrowItemBox>
        </LoginToastBox>
    )
})